// Imports => Constants
import { ENDPOINTS } from '@constants';

export class TicketsAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  list = (params) => {
    return this.Client.get(ENDPOINTS.TICKETS.LIST, { params }).then(
      (response) => response.data.data
    );
  };

  get_by_id = (uid, params) => {
    return this.Client.get(ENDPOINTS.TICKETS.GET_BY_ID(uid), { params }).then(
      (response) => response.data.data
    );
  };

  store = (data) => {
    return this.Client.post(ENDPOINTS.TICKETS.STORE, data).then(
      (response) => response.data
    );
  };
}

export default TicketsAPI;
